import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnEvidence extends SnModel {
  @Expose()
  public incidentId: string;

  @Expose()
  public evidenceTitle: string;

  @Expose()
  public evidenceDescription: string;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
